import vue from "vue";
import ApiService from "@/common/ApiService";
import urlConfig from "@/../public/urlConfig.json";

const apiService = new ApiService(vue.prototype.$config.profileBaseAddress, {
    'Content-Type': 'multipart/form-data',
    "Access-Control-Allow-Origin": "*",
    'Access-Control-Request-Method': "GET,PUT,POST,DELETE",
});

export default ({

    state: {
        files: [],
        imageAddress: ""
    },

    mutations: {
        SetImageAddress(state, imageAddress) {
            state.imageAddress = imageAddress;
        }
    },

    getters: {
        GetImageAddress(state) {
            return state.SliderImageAddress;
        }

    },

    actions: {
        async UploadFiles(context, attachments) {
            try {
                const response = await apiService.Post("source/CreateDocumentAsync", attachments);

                if (response.status == 200) {
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },

        async UpdateUploadFiles(context, attachments) {
            try {
                const response = await apiService.Post("source/UpdateDocumentAsync", attachments);

                if (response.status == 200) {
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },
        async deleteDocument(context, data) {
            try {
                const response = await apiService.Post("source/DeleteDocumentAsync", data);

                if (response.status == 200) {
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },

        async GetFileContent(context, file) {
            try {
                const response = await apiService.Get("source/GetFileContent/" + file.profileId + "/" + file.name);

                if (response.status == 200) {
                    context.commit("SetImageAddress", response.data.data);
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },


    }

});